'use strict';

import { initCharCounters } from './chip-map-char-counter.js';
import { initSubmitOnce } from './chip-map-submit-once.js';

const form = document.querySelector('.cc-chipmap-registration__form');
initCharCounters(form);
initSubmitOnce(form);

/* Blendet nach der Dateiauswahl im "imagesUpload"-Mehrfach-Upload (siehe New.html) pro Datei ein
   eigenes Alt-Text-Feld + einen Entfernen-Button ein, rein clientseitig (kein Zwei-Schritt-Upload
   noetig) - vor dem Absenden des Formulars existiert noch keine sys_file_reference-uid, ueber die
   sich ein Feld sonst eindeutig einer Datei zuordnen liesse. Die Felder werden daher nach AUSWAHL-
   POSITION benannt ("imageAlternatives[1]", "imageAlternatives[2]", ...) - dieselbe Reihenfolge, in
   der Extbase die Dateien beim Upload in die ObjectStorage einsortiert, sodass der Controller
   (StandortSelfServiceController::createAction()) Feld und Datei wieder per Position matchen kann.
   Ohne JavaScript bleibt der Bereich schlicht leer; die Galeriebilder bekommen dann serverseitig den
   automatischen Fallback-Alt-Text (siehe applyDefaultAltText() im Controller). */
(function () {
    const input = document.getElementById('registration-imagesUpload');
    const container = document.getElementById('registration-images-alt-fields');
    if (!input || !container) {
        return;
    }

    const fieldLabel = input.getAttribute('data-alt-field-label') || '';
    const fieldNamePrefix = input.getAttribute('data-alt-field-name-prefix') || 'imageAlternatives';
    const removeLabel = input.getAttribute('data-remove-label') || 'Entfernen';

    // Natives <input type="file" multiple> ERSETZT bei jeder erneuten Dateiauswahl ueber denselben
    // Dialog komplett die bisherige Auswahl (Browser-Standardverhalten, nicht TYPO3-spezifisch) -
    // ohne diesen DataTransfer-Sammel-Speicher wuerde das Hochladen eines zweiten Bildes das zuerst
    // gewaehlte wieder aus input.files werfen (gemeldeter Bug: "erstes Bild wird geloescht, sobald
    // ich ein zweites hochlade"). selection haelt daher die ueber mehrere Dialog-Aufrufe hinweg
    // akkumulierte Gesamtauswahl; input.files wird nach jeder Aenderung/jedem Entfernen komplett
    // aus ihr neu zusammengesetzt, damit das eigentliche Formular-Upload-Feld immer den vollstaendigen
    // Stand traegt.
    const selection = new DataTransfer();

    function renderAltFields() {
        container.innerHTML = '';

        Array.from(input.files || []).forEach(function (file, fileIndex) {
            const position = fileIndex + 1;
            const fieldId = 'registration-imageAlt-' + position;

            const row = document.createElement('div');
            row.className = 'cc-form-row';

            const label = document.createElement('label');
            label.className = 'cc-label';
            label.setAttribute('for', fieldId);
            label.textContent = fieldLabel + ' ' + position + ' (' + file.name + ')';

            const textInput = document.createElement('input');
            textInput.type = 'text';
            textInput.className = 'cc-input';
            textInput.id = fieldId;
            textInput.name = 'tx_chipmap_standortregistration[' + fieldNamePrefix + '][' + position + ']';

            const removeButton = document.createElement('button');
            removeButton.type = 'button';
            removeButton.className = 'cc-chipmap-registration__image-remove';
            removeButton.textContent = removeLabel + ' (' + file.name + ')';
            removeButton.addEventListener('click', function () {
                removeFileAt(fileIndex);
            });

            row.appendChild(label);
            row.appendChild(textInput);
            row.appendChild(removeButton);
            container.appendChild(row);
        });
    }

    function replaceSelectionWith(files) {
        selection.items.clear();
        files.forEach(function (file) {
            selection.items.add(file);
        });
        input.files = selection.files;
        renderAltFields();
    }

    function removeFileAt(indexToRemove) {
        const remaining = Array.from(input.files || []).filter(function (_, index) {
            return index !== indexToRemove;
        });
        replaceSelectionWith(remaining);
    }

    input.addEventListener('change', function () {
        // An dieser Stelle enthaelt input.files NUR die Dateien aus dem soeben geschlossenen
        // Auswahl-Dialog (siehe Kommentar oben) - diese werden der bisherigen Gesamtauswahl
        // hinzugefuegt, nicht als deren Ersatz behandelt.
        replaceSelectionWith(Array.from(selection.files).concat(Array.from(input.files || [])));
    });
})();
